<template>

  <svg
    t="1632727490171"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="7494"
    width="64"
    height="64"
  ><path d="M80.11709262 252.68789795h858.37901954V681.87740704H80.11709262v-858.37901955z" p-id="7495" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconShapeRect',
} as DefineComponent
</script>